module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showNotesInfo":"Show NOTE Counts"},"ja":{"showNotesInfo":"ノートの内訳を表示する"},"zh-Hant":{"showNotesInfo":"顯示 NOTE 數量資訊"},"zh-Hans":{"showNotesInfo":"显示 NOTE 数量信息"}}')
  delete Component.options._Ctor
}
